import Vue from 'vue'
import Picker from 'vue-wheel-picker';

Vue.component('Picker', Picker)